import React from "react";
import { Container, Row, Col } from "shards-react";
import SAPProjects from "../components/sap-projects/Projects";

const SAPProjectsView = props => {
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <SAPProjects />
        </Col>
      </Row>
    </Container>
  );
};

export default SAPProjectsView;
